<div class="form-group mb-4">
  @if (props.text) {
    <label
      [attr.for]="id"
      class="{{colSize}} font-weight-bold form-label align-items-center {{ labelIndentCssClass }}"
      [attr.role]="props.group ? 'presentation' : null"
      >
      <span class="question-label-text" [id]="id + key?.toString()">{{ props.text }}</span>
      @if (props.tooltip) {
        <span
          class="help-tooltip-icon ms-2"
          [ngbTooltip]="tooltipContent"
          tooltipClass="help-tooltip"
          triggers="click"
          role="tooltip"
        ></span>
      }
      <ng-template #tooltipContent>
        <div [innerHtml]="props.tooltip"></div>
      </ng-template>
    </label>
  }

  <div
    class="{{colSize}}"
    [attr.role]="props.group ? 'group' : null"
    [attr.aria-labelledby]="id + key?.toString()"
    [attr.aria-describedby]="props.tooltip ? (id + key?.toString() + '_desc') : null"
    >
    <ng-template #fieldComponent></ng-template>
    @if (props.tooltip) {
      <span id="id + key?.toString() + '_desc'" class="sr-only">{{props.tooltip}}</span>
    }
  </div>
</div>
